import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ab7053e2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ab7053e2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7053e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab7053e2')) {
      api.createRecord('ab7053e2', component.options)
    } else {
      api.reload('ab7053e2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ab7053e2&scoped=true", function () {
      api.rerender('ab7053e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/module/2-1-catalog-list-1/index.vue"
export default component.exports